
import React from 'react';

export const CURRENCY_PAIRS = [
  { name: 'BTC/USDT', type: 'CRYPTO', broker: 'BYBIT' },
  { name: 'ETH/USDT', type: 'CRYPTO', broker: 'BYBIT' },
  { name: 'SOL/USDT', type: 'CRYPTO', broker: 'BYBIT' },
  { name: 'XRP/USDT', type: 'CRYPTO', broker: 'BYBIT' },
  { name: 'AVAX/USDT', type: 'CRYPTO', broker: 'BYBIT' },
  { name: 'MKR/USDT', type: 'CRYPTO', broker: 'BYBIT' },
  { name: 'AAVE/USDT', type: 'CRYPTO', broker: 'BYBIT' },
  { name: 'ADA/USDT', type: 'CRYPTO', broker: 'BYBIT' },
  { name: 'DOT/USDT', type: 'CRYPTO', broker: 'BYBIT' },
  { name: 'LINK/USDT', type: 'CRYPTO', broker: 'BYBIT' },
  { name: 'MATIC/USDT', type: 'CRYPTO', broker: 'BYBIT' },
  { name: 'SHIB/USDT', type: 'CRYPTO', broker: 'BYBIT' },
  { name: 'DOGE/USDT', type: 'CRYPTO', broker: 'BYBIT' },
  { name: 'EUR/USD', type: 'FOREX', broker: 'XTB' },
  { name: 'GBP/USD', type: 'FOREX', broker: 'XTB' },
  { name: 'USD/JPY', type: 'FOREX', broker: 'XTB' },
  { name: 'AUD/USD', type: 'FOREX', broker: 'XTB' },
  { name: 'USD/CHF', type: 'FOREX', broker: 'XTB' },
  { name: 'XAU/USD', type: 'COMMODITY', broker: 'XTB' },
  { name: 'XAG/USD', type: 'COMMODITY', broker: 'XTB' },
];

export const THEME = {
  primary: '#6366f1',
  secondary: '#818cf8',
  background: '#0a0a0b',
  card: '#141416',
  cardBorder: 'rgba(255, 255, 255, 0.08)',
  textMuted: '#94a3b8',
};

export const CryptoLogos = {
  BTC: () => (
    <svg width="100%" height="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="#F7931A"/>
      <path d="M23.189 14.183c.31-2.071-1.266-3.185-3.42-3.928l.699-2.803-1.706-.425-.68 2.73c-.448-.112-.907-.216-1.363-.32l.686-2.753-1.705-.425-.699 2.803c-.371-.084-.733-.167-1.087-.255l.002-.008-2.352-.587-.454 1.82s1.265.29 1.239.308c.69.172.815.63.794 1l-.796 3.193c.047.012.11.028.178.053-.06-.015-.123-.03-.189-.046l-1.115 4.475c-.084.21-.299.525-.783.405.018.026-1.239-.308-1.239-.308l-.847 1.954 2.22.554c.413.103.818.21 1.216.31l-.707 2.843 1.705.426.699-2.803c.465.126.915.244 1.353.354l-.694 2.788 1.706.425.707-2.838c2.91.552 5.101.329 6.023-2.304.743-2.12-.036-3.342-1.57-4.136 1.117-.258 1.958-.992 2.181-2.508zm-3.899 5.484c-.528 2.123-4.1.976-5.257.688l.938-3.763c1.157.288 4.86.858 4.319 3.075zm.53-5.513c-.482 1.93-3.453.95-4.417.71l.85-3.41c.963.24 4.062.689 3.567 2.7zm0 0" fill="white"/>
    </svg>
  ),
  ETH: () => (
    <svg width="100%" height="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="#627EEA"/>
      <path d="M16.498 4v8.87l7.497 3.35L16.498 4z" fill="white" fillOpacity="0.602"/>
      <path d="M16.498 4L9 16.22l7.498-3.35V4z" fill="white"/>
      <path d="M16.498 21.968v6.027L24 17.616l-7.502 4.352z" fill="white" fillOpacity="0.602"/>
      <path d="M16.498 27.995v-6.028L9 17.616l7.498 10.379z" fill="white"/>
      <path d="M16.498 20.573l7.497-4.353-7.497-3.348v7.701z" fill="white" fillOpacity="0.2"/>
      <path d="M9 16.22l7.498 4.353v-7.701L9 16.22z" fill="white" fillOpacity="0.602"/>
    </svg>
  ),
  USDT: () => (
    <svg width="100%" height="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="#26A17B"/>
      <path d="M17.922 17.383v-.002c-.017 0-.034.002-.051.002h-3.738c-.015 0-.03-.002-.045-.002v.002c-2.348-.094-4.14-.543-4.14-1.077 0-.535 1.792-.983 4.14-1.077v2.303h3.834v-2.303c2.345.094 4.135.542 4.135 1.077 0 .534-1.79 1.01-4.135 1.077zm0-3.52v-2.18h4.632v-3.32H9.444v3.32h4.635v2.18c-2.924.133-5.148.82-5.148 1.637 0 .816 2.224 1.503 5.148 1.636v7.357h3.834V15.5c2.92-.132 5.143-.82 5.143-1.636 0-.817-2.222-1.504-5.143-1.637z" fill="white"/>
    </svg>
  ),
  XRP: () => (
    <svg width="100%" height="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="#23292F"/>
      <path d="M16.3 15.1l5.4-5.4c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-5.4 5.4-5.4-5.4c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l5.4 5.4-5.4 5.4c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3l5.4-5.4 5.4 5.4c.2.2.4.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4l-5.4-5.4z" fill="white"/>
    </svg>
  ),
  BNB: () => (
    <svg width="100%" height="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="#F3BA2F"/>
      <path d="M12.116 14.404l3.884-3.884 3.884 3.884L22.217 12l-6.217-6.217L9.783 12l2.333 2.404zm0 3.192l-2.333 2.404L16 26.217l6.217-6.217-2.333-2.404-3.884 3.884-3.884-3.884zm0-1.596l3.884 3.884 3.884-3.884-3.884-3.884-3.884 3.884zm-3.192 1.596l-2.333-2.404 2.333-2.404 2.333 2.404-2.333 2.404zm12.768 0l2.333-2.404-2.333-2.404-2.333 2.404 2.333 2.404z" fill="white"/>
    </svg>
  ),
  TRX: () => (
    <svg width="100%" height="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="#EF0027"/>
      <path d="M16 8l8 8-8 8-8-8 8-8zm0 2.5l-5.5 5.5 5.5 5.5 5.5-5.5-5.5-5.5z" fill="white"/>
    </svg>
  ),
  SOL: () => (
    <svg width="100%" height="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="#000000"/>
      <path d="M7.273 8.209h17.454l-2.727 2.727H4.545l2.728-2.727zm17.454 5.064H7.273l2.727-2.727h17.454l-2.727 2.727zm-17.454 5.064h17.454l-2.727 2.727H4.545l2.728-2.727z" fill="#14F195"/>
    </svg>
  ),
};

export const Icons = {
  Chart: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18"/><path d="m19 9-5 5-4-4-3 3"/></svg>
  ),
  Deals: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
  ),
  Robot: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 8V4H8"/><rect width="16" height="12" x="4" y="8" rx="2"/><path d="M2 14h2"/><path d="M20 14h2"/><path d="M15 13v2"/><path d="M9 13v2"/></svg>
  ),
  Support: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
  ),
  Account: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
  ),
  Wallets: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="14" x="2" y="5" rx="2"/><line x1="2" x2="22" y1="10" y2="10"/></svg>
  ),
  Deposit: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12l7 7 7-7"/></svg>
  ),
  Withdraw: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>
  ),
  Check: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
  ),
};
